/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

google.charts.load('current', { packages: ['corechart'] });
